export class PureDate {
  day: number;
  month: number;
  year: number;

  constructor(day: number, month: number, year: number) {
    this.day = day;
    this.month = month;
    this.year = year;
  }

  public convertToDate(): Date | undefined {
    if (!this.day || !this.month || !this.year) {
      return undefined;
    }
    return new Date(this.year, this.month - 1, this.day);
  }

  public isValid(): boolean {
    const date = this.convertToDate();
    if (!date) return false;
    return date.getDate() === this.day && date.getMonth() + 1 === this.month && date.getFullYear() === this.year;
  }
}
